





















import EmployeeAttendDayViewLine from "@/components/EmployeeAttendDayViewLine.vue";
import EmployeeAttendViewPairLine from "@/components/EmployeeAttendViewPairLine.vue";
import EmployeeAttendViewShift from "@/components/EmployeeAttendViewShift.vue";
import SupportTooltip from "@/components/Support/SupportTooltip.vue";
import { AppConstants } from "@/core/Export";
import store from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {
    EmployeeAttendDayViewLine,
    EmployeeAttendViewPairLine,
    EmployeeAttendViewShift,
    SupportTooltip,
  },
})
export default class EmployeeAttendView extends Vue {
  @Prop({ default: false }) useNominations: boolean;
  @Prop({ default: false }) isStandBy: boolean;

  attendColumns: Array<any>;
  pagination = {
    rowsPerPage: 0,
  };
  constructor() {
    super();
    this.attendColumns = new Array<any>();
  }

  created() {
    this.onSetAttendColumns();
  }

  mounted() {
    this.fixTableScrollingIssue();
  }

  fixTableScrollingIssue() {
    var isIOSDevice = !!navigator.platform.match(/iPhone|iPod|iPad/);
    if (isIOSDevice && this.appEnv.isRtl) {
      let q_table_middle = document.getElementsByClassName(
        "q-table__middle"
      )[0] as HTMLElement;
      if (q_table_middle) {
        q_table_middle.style.direction = "ltr";
        let table = q_table_middle.firstElementChild as HTMLElement;
        table.style.direction = "rtl";
      }
    }
  }

  onSetAttendColumns() {
    this.attendColumns.push({
      name: "date",
      field: "date",
      label: this.$t("pages.employeeAttendDetails.date"),
      align: "left",
      style: "width: 105px;",
    });
    this.attendColumns.push({
      name: "day",
      field: "day",
      label: this.$t("pages.employeeAttendDetails.day"),
      align: "left",
      style: "width: 105px;",
    });
    this.attendColumns.push({
      name: "additionals",
      field: "additionals",
      label: "",
      align: "left",
      style: "width: 5px;",
    });
    this.attendColumns.push({
      name: "status",
      field: "status",
      label: "",
      align: "left",
      style: "width: 5px;",
    });
    this.attendColumns.push({
      name: "pairsNo",
      field: "pairsNo",
      label: "",
      align: "left",
      style: "width: 10px;",
    });
    this.attendColumns.push({
      name: "entry",
      field: "entry",
      label: this.isAllowViewAttendAndSummaries ? this.$t("pages.employeeAttendDetails.entry") : "",
      align: "left",
      style: "width: 105px;",
    });
    this.attendColumns.push({
      name: "exit",
      field: "exit",
      label: this.isAllowViewAttendAndSummaries ? this.$t("pages.employeeAttendDetails.exit") : "",
      align: "left",
      style: "width: 105px;",
    });
    this.attendColumns.push({
      name: "event",
      field: "event",
      label: this.isAllowViewAttendAndSummaries ? this.$t("pages.employeeAttendDetails.event") + "/" + this.$t("pages.employeeAttendDetails.specialEvent") : "",
      align: "left",
      supportText: "supportText.eventSupport",
    });
    this.attendColumns.push({
      name: "workingHoursActual",
      field: "workingHoursActual",
      label: this.isAllowViewAttendAndSummaries ? this.$t("pages.employeeAttendDetails.workingHoursActual") : "",
      align: "left",
      supportText: "supportText.workingHoursActualSupport",
    });
    this.attendColumns.push({
      name: "std",
      field: "std",
      label: this.isAllowViewAttendAndSummaries ? this.$t("pages.employeeAttendDetails.std") : "",
      align: "left",
      style: "width: 105px;",
      supportText: "supportText.stdTimeSupport",
    });
    this.attendColumns.push({
      name: "missingHours",
      field: "missingHours",
      label: this.isAllowViewAttendAndSummaries ? this.$t("pages.employeeAttendDetails.missingHours") : "",
      align: "left",
      style: "width: 105px;",
      supportText: "supportText.hoserHoursSupport",
    });
    this.attendColumns.push({
      name: "regularHours",
      field: "regularHours",
      label: this.isAllowViewAttendAndSummaries ? this.$t("pages.employeeAttendDetails.regularHours") : "",
      align: "left",
      style: "width: 105px;",
      supportText: "supportText.regularHoursSupport",
    });
    this.attendColumns.push({
      name: "extraHours",
      field: "extraHours",
      label: this.isAllowViewAttendAndSummaries ? this.$t("pages.employeeAttendDetails.extraHours") : "",
      align: "left",
      style: "width: 105px;",
      supportText: "supportText.overTimeHoursSupport",
    });
    this.attendColumns.push({
      name: "errors",
      field: "errors",
      label: this.isAllowViewAttendAndSummaries ? this.$t("pages.employeeAttendDetails.errors") : "",
      align: "left",
      supportText: "supportText.noOfAMRErrorsSupport",
    });
    this.attendColumns.push({
      name: "notes",
      field: "notes",
      label: this.isAllowViewAttendAndSummaries ? this.$t("pages.employeeAttendDetails.notes") : "",
      align: "left",
    });
    this.attendColumns.push({
      name: "hasHealthDeclaration",
      field: "hasHealthDeclaration",
      label: this.healthDeclarationIsVisible && this.isAllowViewAttendAndSummaries
        ? this.$t("health_declaration.title_to_talbe")
        : "",
      align: "left",
      style: "width: 10px;",
    });
    this.attendColumns.push({
      name: "expand",
      field: "expand",
      align: "left",
      style: "width: 10px;",
    });
  }

  onGetVisibleColumns() {
    if (this.$q.screen.xs) {
      return [
        "date",
        "day",
        "additionals",
        "status",
        "entry",
        "exit",
        "workingHoursActual",
        "event",
        "hasHealthDeclaration",
        "expand",
      ];
    }
  }
  @Watch("employeeAttendViewData.healthDeclarationIsVisible")
  changeHealthDeclarationLabel() {
    let HealthDeclarationColumn = this.attendColumns.find(
      (x) => x.name == "hasHealthDeclaration"
    );
    if (HealthDeclarationColumn) {
      HealthDeclarationColumn.label = this.healthDeclarationIsVisible && this.isAllowViewAttendAndSummaries
        ? this.$t("health_declaration.title_to_talbe")
        : "";
    }
  }

  get employeeAttendViewLines() {
    return store.getters.employeeAttendViewData.lines.filter(q => q.typeCode != "W");
  }

  get healthDeclarationIsVisible() {
    return this.employeeAttendViewData.healthDeclarationIsVisible;
  }

  get employeeAttendViewData() {
    return store.getters.employeeAttendViewData;
  }

  get isAllowViewAttendAndSummaries() {
    if (
      this.appEnv.isAllowed(
        AppConstants.Permissions.PortalLimitViewAtAttendanceAndSummaries
      )
    ) {
      return false;
    }
    return true;
  }

  get appEnv() {
    return store.getters.appEnv;
  }
}
